import { render, staticRenderFns } from "./ClarityOrderBreadcrumbs.vue?vue&type=template&id=50ca73d2&"
import script from "./ClarityOrderBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./ClarityOrderBreadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports